import Vue from "vue";
import * as types from "../types.js";
import api from "../../api/index.js";
import { startNotice } from "../../notice/index.js";
import config from '../../config.js'
const siteConfig = config[process.env.NODE_ENV]
const defaultLang = siteConfig.defalultLang
const ls = localStorage;
const state = {
  authInfo: null,
  lang: "",
  token: ""
};



const getters = {
  authInfo: state => state.authInfo,
  lang: state => state.lang,
  token: state => state.token
};

const actions = {
  login({ commit, state }, user) {
    return new Promise((resolve, reject) => {
      api.doLogin(user).then(res => {
        let token = res.data.token;
        let userInfo = res.data.userInfo;
        commit(types.LANG, userInfo.lang || defaultLang);
        if (userInfo.status) {
          commit(types.USER_TOKEN, token);
          commit(types.AUTH_INFO, userInfo);
          ls.setItem("user", token);
          ls.removeItem("email");
        }
        resolve(userInfo)
      }).catch(err => {
        reject(err)
      })
    })
  },
  auth({ commit, state }) {
    return new Promise((resolve) => {
      if (state.authInfo) {
        resolve({ userInfo: state.authInfo })
        return
      }
      if (!ls.getItem("user")) {
        resolve()
        return
      }
      api.auth().then(res => {
        let { token, userInfo } = res.data;
        let userLang = userInfo.lang || defaultLang;
        ls.setItem("user", token);
        ls.setItem('lang', userLang)
        commit(types.AUTH_INFO, userInfo);
        commit(types.USER_TOKEN, token);
        commit(types.LANG, userLang);
        resolve({ userInfo, userLang });
      }).catch(err => {
        if (err.response.status != 502) {
          ls.removeItem("user");
        }
        resolve();
      });
    })
  },
  doLogin({ commit, state }, { token, userInfo }) {
    if (userInfo.lang) {
      commit(types.LANG, userInfo.lang);
    }
    if (userInfo.status) {
      commit(types.USER_TOKEN, token);
      commit(types.AUTH_INFO, userInfo);
      ls.setItem("user", token);
      ls.removeItem("email");
    }
  },
  doLogout({ commit, state }) {
    commit(types.AUTH_INFO, null);
    ls.removeItem("user");
    Vue.prototype.$ws.send("close");
    location.reload();
  }
};

const mutations = {
  [types.AUTH_INFO](state, authInfo) {
    state.authInfo = authInfo;
  },
  [types.LANG](state, lang) {
    state.lang = lang;
    ls.setItem("lang", lang);
  },
  [types.USER_TOKEN](state, token) {
    state.token = token;
    if (token) {
      startNotice(token);
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
